import { Card, CardContent, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1),
  background: '#FFFFFF',
  border: '1px solid rgba(0, 0, 0, 0.06)',
  cursor: 'pointer',
  position: 'relative',
  overflow: 'hidden',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: theme.palette.accent.gradient,
    transform: 'scaleX(0)',
    transformOrigin: 'left',
    transition: 'transform 0.3s ease',
  },

  '&:hover': {
    '&::before': {
      transform: 'scaleX(1)',
    },
    '& .arrow-icon': {
      transform: 'translateX(4px)',
      color: theme.palette.primary.main,
    },
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  width: '60px',
  height: '60px',
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.1) 0%, rgba(91, 141, 239, 0.1) 100%)',
  marginBottom: theme.spacing(2.5),

  '& svg': {
    fontSize: '28px',
    color: theme.palette.primary.main,
  },
}));

export default function ServiceCard({ icon, title, description, onClick }) {
  return (
    <StyledCard onClick={onClick}>
      <CardContent sx={{ flexGrow: 1, p: 3 }}>
        <IconWrapper>{icon}</IconWrapper>

        <Typography
          variant="h5"
          component="h3"
          sx={{
            mb: 1.5,
            fontWeight: 600,
            color: 'text.primary',
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            lineHeight: 1.7,
            mb: 2,
          }}
        >
          {description}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: 'text.secondary',
            mt: 'auto',
          }}
        >
          <ArrowForwardIcon
            className="arrow-icon"
            sx={{
              fontSize: '18px',
              transition: 'all 0.3s ease',
            }}
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
}
